import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import newNotificationSound from '@toolify/client/src/assets/sounds/new-notification.wav'

import {getEntityNameByEntity} from '@toolify/client/src/modules/entities/functions/getEntityNameByEntity'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

export class IncomingCallNotificationStrategy extends DefaultNotificationStrategy<NotificationType.IncomingCall> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.IncomingCall>, authorNick: string): IBrowserNotification {
    const title = `${authorNick} is calling you`
    const body = `${getEntityNameByEntity(notification.authorEntity)} is calling you`
    const sound = newNotificationSound
    return {
      sound,
      title,
      body,
    }
  }
}
